
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/view-project/[dealId]",
      function () {
        return require("private-next-pages/view-project/[dealId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/view-project/[dealId]"])
      });
    }
  